<template>
    <v-dialog :value="value" max-width="620" persistent @input="$emit('input', $event)">
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">{{ question && question.id ? "Editar pergunta" : "Nova pergunta" }}</h3>
                    <p class="ui-section-description">{{ description }}</p>
                </div>
            </div>
            <div class="ui-card__body">
                <v-textarea v-model="form.text" label="Pergunta" outlined rows="2" auto-grow hide-details="auto" counter="1000" maxlength="1000" class="mb-3"></v-textarea>
                <v-select v-model="form.answer_type" :items="answerTypes" item-value="value" item-text="text" label="Forma de responder" outlined dense
                    hide-details="auto" :menu-props="{ offsetY: true }" class="mb-3"></v-select>
                <v-textarea v-if="isChoice" v-model="form.options" label="Opções (uma por linha)" outlined rows="4" auto-grow hide-details="auto" class="mb-3"
                    placeholder="Soja&#10;Milho&#10;Trigo"></v-textarea>
                <v-text-field v-model="form.help" label="Texto de ajuda (opcional)" outlined dense hide-details="auto" maxlength="1000" class="mb-1"
                    placeholder="Ex.: some todas as propriedades"></v-text-field>
                <v-switch v-model="form.required" inset dense hide-details class="mt-3" label="Resposta obrigatória"></v-switch>
            </div>
            <div class="ui-card__footer">
                <v-btn outlined :disabled="saving" @click="$emit('input', false)">Cancelar</v-btn>
                <v-btn v-if="$allowed($route.path.endsWith('/questionario') ? 'rma.template' : 'rma.questionnaire')" color="primary" depressed :loading="saving" :disabled="!canSave" @click="save">Salvar pergunta</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
// Editor de pergunta do questionario (modelo ou caso): texto, forma de responder,
// opcoes (escolha unica/multipla), ajuda e obrigatoriedade.
export default {
    name: "RmaQuestionDialog",

    props: {
        value: { type: Boolean, default: false },
        question: { type: Object, default: null },
        answerTypes: { type: Array, default: () => [] },
        saving: { type: Boolean, default: false },
        description: { type: String, default: "A recuperanda vê a pergunta e o texto de ajuda no Painel da Devedora." },
    },

    data: () => ({ form: { text: "", answer_type: "short_text", options: "", help: "", required: true } }),

    computed: {
        isChoice() {
            return ["single_choice", "multiple_choice"].includes(this.form.answer_type);
        },
        canSave() {
            if (this.form.text.trim().length < 3 || !this.form.answer_type) return false;
            if (this.isChoice) return this.form.options.split("\n").map((option) => option.trim()).filter(Boolean).length >= 2;
            return true;
        },
    },

    watch: {
        value(open) {
            if (!open) return;
            const q = this.question || {};
            this.form = {
                text: q.text || "",
                answer_type: q.answer_type || "short_text",
                options: (q.options || []).join("\n"),
                help: q.help || "",
                required: q.required !== undefined ? !!q.required : true,
            };
        },
    },

    methods: {
        save() {
            this.$emit("save", {
                id: this.question && this.question.id ? this.question.id : null,
                text: this.form.text.trim(),
                answer_type: this.form.answer_type,
                options: this.isChoice ? this.form.options.split("\n").map((option) => option.trim()).filter(Boolean) : null,
                help: this.form.help.trim(),
                required: this.form.required,
            });
        },
    },
};
</script>
